import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { supabase } from '../../supabaseClient';

export function SelectCompany({ selectedCompanyId, setSelectedCompanyId }) {
    const [companies, setCompanies] = useState([]);
  
    useEffect(() => {
      fetchCompanies();
    }, []);
  
    useEffect(() => {
      // Set the default selected company if available
      if (companies.length > 0 && !selectedCompanyId) {
        setSelectedCompanyId(companies[0].id);
      }
    }, [companies]);
  
    const fetchCompanies = async () => {
      try {
        const { data } = await supabase.from('companies').select('id, name');
        setCompanies(data);
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    };

    function handlechange(event) {
        setSelectedCompanyId(event.target.value)
    }

    return (
      <FormControl>
        <InputLabel id="company-select-label">Empresa</InputLabel>
        <Select
          labelId="company-select-label"
          id="company-select"
          value={selectedCompanyId}
          onChange={handlechange}
        >
          {companies.map((company) => (
            <MenuItem key={company.id} value={company.id}>
              {company.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }